import loadingImg from "../assets/robot-loader.gif";
export const tmpl = `<div class="sh-widget-geo-container">
    <div class="sh-widget-loader">
        <img src="${loadingImg}" alt="Loading...">
    </div>
    <h5 data-element="title"></h5>
    <div class="sh-widget-geo-map" data-element="map"></div>
</div>`;
